import { endPointBulkCartUpdate, getEPProductUpdates } from "../../main/services/endpoints"
import { FetchDataOptions } from "modules/main/services/fetchData";
import { ProductUpdates } from "../types/updates";
import { AddCartMethod } from "modules/cart/types/add-cart-methods";
import { AuthError } from "modules/authentication/types/form-login-types";
import apiClient from "modules/main/services/apiClient";



export const getUpdates = async (
    canonicalSku: string,
    method: AddCartMethod,
    abortController?: AbortController
): Promise<ProductUpdates> =>  {
    const controller = abortController || new AbortController();
    const signal = controller.signal;
    const defaultOptions:FetchDataOptions = {
        method:"GET",
        headers:{},
        body:undefined,
        credentials:"include",
    }
    try{
        const response = await fetch(getEPProductUpdates(canonicalSku),{
                            // method:defaultOptions.method,
                            headers:defaultOptions.headers,
                            body:JSON.stringify(defaultOptions.body),
                            credentials:defaultOptions.credentials,
                            signal}); 
        if(!response.ok){
            if (response.status === 401){
                throw new AuthError("Unauthorized");
            }
            throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        return data
    }
    catch(error){
        throw error;
    }
    

}

/**
 * Sends one non-blocking batch product update trigger to the backend.
 * The backend derives the affected items from the execution id, so the
 * request carries only `execution_id`.
 * @param executionId UUID of the completed list execution.
 */
export const triggerBatchProductUpdates = async (executionId: string): Promise<void> => {
    if (!executionId) return;
    await apiClient.post(endPointBulkCartUpdate(), { execution_id: executionId });
};
